<script setup lang="ts">
import { defineProps } from 'vue';
import DropdownTitleHover from '../common/Dropdown/DropdownTitleHover.vue';
import Dropdown from '../common/Dropdown/Dropdown.vue';
import TeamIcon from '../icons/TeamIcon.vue';
import LockIcon from '../icons/LockIcon.vue';
import FolderIcon from '../icons/FolderIcon.vue';
import ContextMenuButton from '../common/ContextMenu/ContextMenuButton.vue';
import { ProjectVisibility } from '../../../types/project_visibility';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import DropdownArrowIcon from '@/dashboard/vue/components/icons/DropdownArrowIcon.vue';

const props = defineProps<{
  current: ProjectVisibility;
  owner: boolean;
  editable: boolean;
  isWorkspace: boolean;
}>();
</script>

<template>
  <Dropdown v-if="props.editable" body-class="mt-xxs">
    <template #title="{ isOpen }: any">
      <DropdownTitleHover :is-active="isOpen">
        <div class="flex h-[24px] items-center gap-xs">
          <span v-if="props.current === 'link'" class="flex items-center gap-xs">
            <FolderIcon class="stroke-black dark:stroke-gray-500" />
            <span class="text-[14px] text-brand-cta">Viewable via link</span>
          </span>

          <span v-else-if="props.current === 'team'" class="flex items-center gap-xs">
            <TeamIcon class="stroke-black dark:stroke-gray-500" />
            <span v-if="props.isWorkspace" class="text-[14px] text-black dark:text-gray-500">Workspace shared with the team</span>
            <span v-else class="text-[14px] text-black dark:text-gray-500">Shared with the team</span>
          </span>

          <span v-else-if="props.current === 'private'" class="flex items-center gap-xs">
            <LockIcon stroke-class="stroke-black dark:stroke-gray-500" fill-class="fill-black dark:fill-gray-500" />
            <span class="text-[14px] text-black dark:text-gray-500">Private</span>
          </span>

          <DropdownArrowIcon class="stroke-black dark:stroke-gray-500" />
        </div>
      </DropdownTitleHover>
    </template>
    <template #body>
      <ContextMenuButton :need-dark="true">
        <div class="flex items-center gap-[10px] whitespace-nowrap">
          <LockIcon stroke-class="stroke-black dark:stroke-gray-500" fill-class="fill-black dark:fill-gray-500" />
          <span class="text-caption-s text-black dark:text-gray-500">Make Private</span>
        </div>
      </ContextMenuButton>

      <Divider class="mx-[8px]" />

      <ContextMenuButton :need-dark="true">
        <div class="flex items-center gap-[10px] whitespace-nowrap">
          <LockIcon stroke-class="stroke-black dark:stroke-gray-500" fill-class="fill-black dark:fill-gray-500" />
          <span class="text-caption-s text-black dark:text-gray-500">Make Private</span>
        </div>
      </ContextMenuButton>
    </template>
  </Dropdown>

  <div v-else class="flex h-[24px] items-center gap-xs text-[14px] text-black dark:text-gray-500">
    <span v-if="props.current === 'link'" class="flex items-center gap-xs">
      <FolderIcon class="stroke-black dark:stroke-gray-500" />
      <span class="">Viewable via link</span>
    </span>

    <span v-else-if="props.current === 'team'" class="flex items-center gap-xs">
      <TeamIcon class="stroke-black dark:stroke-gray-500" />
      <span v-if="props.isWorkspace" class="">Workspace shared with the team</span>
      <span v-else class="">Shared with the team</span>
    </span>

    <span v-else-if="props.current === 'private'" class="flex items-center gap-xs">
      <LockIcon stroke-class="stroke-black dark:stroke-gray-500" fill-class="fill-black  dark:fill-gray-500" />
      <span class="">Private</span>
    </span>
  </div>
</template>
